'use client';

import NextImageView from '@/components/ui/NextImageView/NextImageView';
import type { GfWorkDetail } from '@/features/gfWorks/types';
import { SnsType } from '@/features/gfWorks/types';
import { formatWorkDate } from '@/features/gfWorks/utils/functions';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { formatCreatorNames } from '@/utils/formatters';
import { getImageLayoutSizes } from '@/utils/nextImage';
import styles from './WorksDetailThumbnail.module.scss';

function WorksDetailThumbnail({ work }: { work: GfWorkDetail }) {
  const showRelatedInfo = work.url || work.sns.some((snsGroup) => snsGroup.links?.length > 0);
  const logoPath = work.logoPath;
  return (
    <div className={styles.worksDetailHeaderContainer}>
      {logoPath && (
        <div className={styles.workImageContainer}>
          <NextImageView
            src={logoPath}
            alt={work.name}
            fill
            sizes={getImageLayoutSizes({ sp: '24vw', pc: '360px' })}
            objectFit='contain'
          />
        </div>
      )}
      <div className={styles.workInfo}>
        <div className={`${utilsStyles.onlySp} ${styles.workTitle}`}>{work.name}</div>
        <div className={`${utilsStyles.onlySp} ${styles.creators}`}>{formatCreatorNames(work.creators)}</div>
        <div className={styles.serialization}>
          連載 :
          <br className={utilsStyles.onlyPc} />
          {formatWorkDate(work.startDate, work.startIssueNumber)}
          &nbsp;〜&nbsp;
          {formatWorkDate(work.endDate, work.endIssueNumber)}
        </div>
        {showRelatedInfo && (
          <div className={styles.relatedInfo}>
            <p className={styles.relatedInfoLabel}>関連情報：</p>
            <ul className={styles.relatedInfoList}>
              {work.url && (
                <li>
                  <a href={work.url} target='_blank' rel='noopener noreferrer' className={styles.relatedInfoLink}>
                    {work.name}（S-MANGA）
                  </a>
                </li>
              )}
              {work.sns.map((snsGroup) =>
                snsGroup.links?.map((link) => (
                  <li key={link.id}>
                    <a href={link.link} target='_blank' rel='noopener noreferrer' className={styles.relatedInfoLink}>
                      {snsGroup.label}（{SnsType[link.type]?.text ?? link.label}）
                    </a>
                  </li>
                )),
              )}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default WorksDetailThumbnail;
